import { createReducer, PayloadAction } from '@reduxjs/toolkit';
import * as ActionTypes from '../actions/types';
import GENERAL_FUNCTIONS from '../utils/functions/functions';
import { AragButtons } from '../actions/applicationSettings';

interface ApiApplicationSettings {
    mobileScreenSizeWidth: number;
    maxAttachmentSizeInMB: number;
    enableCaptcha: boolean;
    enableAutoSave: boolean;
    isSwitchingLanguageEnabled: boolean;
    aragTelephoneNumber: string;
    aragSubText: string;
    aragImageHeroArea: string;
    aragHeaderText: string;
    aragCollapsedImageHeroArea: string;
    aragButtons: Array<AragButtons>;
}
type State = {
    apiApplicationSettings: ApiApplicationSettings | any;
    loading: boolean;
};
const INITIAL_STATE: State = {
    apiApplicationSettings: {},
    loading: false,
};

const fetchApplicationSettings = (state: State) => {
    return {
        ...state,
        loading: true,
    };
};

const fetchApplicationSettingsSuccess = (
    state: State,
    action: PayloadAction<ApiApplicationSettings>,
): State => {
    return {
        ...state,
        loading: false,
        apiApplicationSettings: GENERAL_FUNCTIONS.extractDataFromResponseObject(
            action.payload,
        ),
    };
};

const fetchApplicationSettingsFailed = (state: State): State => {
    return {
        ...state,
        loading: false,
    };
};

const applicationSettings = createReducer(INITIAL_STATE, {
    [ActionTypes.FETCH_APPLICATION_SETTINGS]: fetchApplicationSettings,
    [ActionTypes.FETCH_APPLICATION_SETTINGS_SUCCESS]:
        fetchApplicationSettingsSuccess,
    [ActionTypes.FETCH_APPLICATION_SETTINGS_FAILED]:
        fetchApplicationSettingsFailed,
});

export default applicationSettings;
